import React, { useEffect, useState } from "react";
import "../../css/empresa_uno/product.css";
import "../../css/table.css";
import { useParams } from "react-router-dom";
import buscar_azul from "../../images/search_azul.png";
import { Preloader } from "../../components/Preloader";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { ModalNuevoCliente } from "../../components/empresa_uno_comp/ModalNuevoCliente";
import { ApiService } from "../../components/ApiService";
import { ModalEditClienteEmpresa } from "../../components/Modales/ModalEditClienteEmpresa";
import { Stack, Alert, Box, Typography, Tooltip, Button } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import VisibilityOffRoundedIcon from "@mui/icons-material/VisibilityOffRounded";
import { DataGrid } from "@mui/x-data-grid";
import { useCompanyAssigned } from "../../components/CompanyAssignedContext";
import LupaIcon from "../../svg/lupaIcon";
import TablesMobile from "../../components/empresa/TablesMobile";
import SearchCompany from "./SearchCompany";

export const Clientes = ({ selectedSucursal, permisos, loadImageS }) => {
	const { nit } = useParams();
	const [clientes, setClientes] = useState([]);
	const [filteredClientes, setFilteredClientes] = useState([]);
	const [search, setSearch] = useState("");
	const [loading, setLoading] = useState(true);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isModalEditClientOpen, setIsModalEditClientOpen] = useState(false);
	const [selectedClient, setSelectedClient] = useState({});
	const [snackBarOpen, setSnackBarOpen] = useState(false);
	const [snackBarMessage, setSnackBarMessage] = useState("");
	const [snackBarType, setSnackBarType] = useState("");

	const [currentAction, setCurrentAction] = useState("show");
	const [currentSize, setCurrentSize] = useState(window.innerWidth);

	useEffect(() => {
		const handleResize = () => {
			setCurrentSize(window.innerWidth);
		};

		window.addEventListener('resize', handleResize);

		// Cleanup function para quitar el listener cuando el componente se desmonte
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	let realAuthCode = "";

	const handleOpenModal = () => {
		setIsModalOpen(true);
	};

	const handleCloseModal = () => {
		setIsModalOpen(false);
	};

	const prepareDataForGrid = (data) => {
		return data.map((item, index) => ({
			...item,
			id: item.key_client || `row-${index}`,
		}));
	};

	const fetchClientes = async () => {
		setLoading(true);
		try {
			const url = `api/company/clients?key_branch=${selectedSucursal}`;
			const options = { method: "GET" };

			const response = await ApiService.fetchData(url, options);
			if (!response) {
				throw new Error("Error al cargar los clientes");
			}

			setClientes(response);
			setFilteredClientes(response);
		} catch (error) {
			throw new Error("Error al cargar los clientes");
		} finally {
			setLoading(false);
		}
	};

	const handleCloseEditModal = () => {
		setSelectedClient({});
		setIsModalEditClientOpen(false);
	};

	const actionModalClient = (cliente, action = "edit") => {
		setSelectedClient(cliente);
		setIsModalEditClientOpen(true);

		setCurrentAction(action);
	};

	useEffect(() => {
		fetchClientes();
	}, [realAuthCode]);

	// Actualiza los clientes filtrados en función de la búsqueda
	useEffect(() => {
		if (search.trim() === "") {
			setFilteredClientes(clientes);
		} else {
			const filtered = clientes.filter(
				(cliente) =>
					cliente.fullName.toLowerCase().includes(search.toLowerCase()) || cliente.phone.includes(search)
			);
			setFilteredClientes(filtered);
		}
	}, [search, clientes]);

	const handleClientUpdated = (updatedClient) => {
		const updatedClientes = clientes.map((cliente) =>
			cliente.key_client === updatedClient.key_client ? updatedClient : cliente
		);

		setClientes(updatedClientes);
		setFilteredClientes(updatedClientes);
	};

	const deleteCliente = async (clienteId) => {
		const url = `api/company/clients/delete?key_branch=${selectedSucursal}`;
		const body = {
			method: "DELETE",
			body: JSON.stringify({ key_client: clienteId }),
		};
		const response = await ApiService.fetchData(url, body);
		if (response?.code === 200) {
			const updatedClientes = clientes.filter((cliente) => cliente.key_client !== clienteId);
			setClientes(updatedClientes);
			setFilteredClientes(updatedClientes);
			setSnackBarMessage(response.message);
			setSnackBarType("success");
			setSnackBarOpen(true);
			return response;
		}
	};

	const getDataGridColumns = () => [
		{
			field: "fullName",
			headerName: "Cliente",
			flex: 1,
		},
		{
			field: "date",
			headerName: "Fecha",
			flex: 1,
		},
		{
			field: "phone",
			headerName: "Teléfono",
			flex: 1,
			renderCell: (params) => (
				<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
					<span>{params.row.phone || "Sin teléfono"}</span>
					{params.row.phone && (
						<a
							href={`https://wa.me/${params.row.codePhone}${params.row.phone}`}
							target="_blank"
							rel="noopener noreferrer"
							style={{
								backgroundColor: "#25D366",
								borderRadius: "50%",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								width: "24px",
								height: "24px",
								textDecoration: "none",
							}}>
							<WhatsAppIcon style={{ color: "white", fontSize: "18px" }} />
						</a>
					)}
				</div>
			),
		},
		{
			field: "location",
			headerName: "Ubicación",
			flex: 1,
		},
		{
			field: "actions",
			headerName: "Acciones",
			sortable: false,
			align: "center",
			headerAlign: "center",
			flex: 1,
			renderCell: (params) => {
				return (
					<Stack
						direction="row"
						spacing={1}
						justifyContent="center"
						alignItems="center"
						sx={{
							width: "100%",
							height: "100%",
							display: "flex",
						}}>
						{
							permisos?.detail && (
								<Tooltip title="Ver detalles">
									<IconButton size="small"
										onClick={(event) => {
											event.stopPropagation();
											actionModalClient(params.row, "read");
										}}
									>
										<RemoveRedEyeRoundedIcon sx={{ color: "#0468fb" }} />
									</IconButton>
								</Tooltip>
							)
						}

						{
							permisos?.edit && (
								<Tooltip title={"Editar"}>
									<IconButton
										onClick={(event) => {
											event.stopPropagation();
											actionModalClient(params.row);
										}}
										size="small">
										<EditRoundedIcon />
									</IconButton>
								</Tooltip>
							)

						}

						{
							permisos?.deleteP && (
								<Tooltip title={"Eliminar"}>
									<IconButton
										size="small"
										onClick={(event) => {
											event.stopPropagation();
											deleteCliente(params.row.key_client);
										}}>
										<DeleteRoundedIcon />
									</IconButton>
								</Tooltip>
							)
						}

					</Stack>
				);
			},
		},
	];

	return (
		<>
			<div className="functionality-container">
				<div>
					<h2 style={{ color: 'var(--theme-company)' }}>Clientes</h2>
				</div>

				<SearchCompany theme={'var(--theme-company)'} valor={search} setValor={(event) => setSearch(event.target.value)} placeholder="Clientes" />

				<div className="content-btn-add">
					{
						permisos?.insert && (
							<Button
								variant="contained"
								sx={{ fontWeight: "bold", letterSpacing: "1px", background: 'var(--theme-company)' }}
								onClick={handleOpenModal}>
								Nuevo Cliente
							</Button>
						)
					}
				</div>
			</div>

			<div className="datatable-container">
				{loading ? (
					<Preloader />
				) : (
					currentSize > 450 ? (
						<div className="table-view-pc">
							<Box sx={{ width: "100%", height: "calc(100vh - 200px)" }}>
								<DataGrid
									density={"comfortable"}
									rows={prepareDataForGrid(filteredClientes)}
									columns={getDataGridColumns()}
									initialState={{
										pagination: {
											paginationModel: { pageSize: 10, page: 0 },
										},
									}}
									pageSizeOptions={[5, 10, 25, 50]}
									pagination
									localeText={{
										MuiTablePagination: {
											labelRowsPerPage: "Filas por pagina:",
											labelDisplayedRows: ({ from, to, count }) =>
												`${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
										},
									}}
									disableColumnMenu={true}
									disableRowSelectionOnClick
									slots={{
										noRowsOverlay: () => (
											<Box
												sx={{
													display: "flex",
													flexDirection: "column",
													alignItems: "center",
													justifyContent: "center",
													height: "100%",
												}}>
												<VisibilityOffRoundedIcon
													sx={{ fontSize: 40, color: 'var(--theme-company)', mb: 1 }}
												/>
												<Typography variant="h6" color="textSecondary">
													No hay clientes disponibles
												</Typography>
											</Box>
										),
									}}
									sx={{
										"& .MuiDataGrid-columnHeader": {
											backgroundColor: 'var(--theme-company)',
											color: "white",
											fontWeight: "bold",
										},
									}}
								/>
							</Box>
						</div>
					) : (
						<TablesMobile loadImageS = { loadImageS } itsCompany={false} filteredData={(filteredClientes ?? []).map(obj => ({
							img: obj?.profile_url,
							title: obj?.fullName,
							texto: 'ID: ' + obj?.dni,
							fullPhone: obj?.codePhone + obj?.phone,
						}))} profile={true} whatsapp={true} type={'profile'} />
					)
				)}
			</div>

			<ModalNuevoCliente isOpen={isModalOpen} onClose={handleCloseModal} keyBranch={selectedSucursal} />
			<ModalEditClienteEmpresa
				isOpen={isModalEditClientOpen}
				clienteEmpresa={selectedClient}
				onClose={handleCloseEditModal}
				keyBranch={selectedSucursal}
				onClientUpdated={handleClientUpdated}
				action={currentAction}
			/>
			<Snackbar
				anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
				open={snackBarOpen}
				autoHideDuration={2600}
				onClose={() => setSnackBarOpen(false)}>
				<Alert
					onClose={() => setSnackBarOpen(false)}
					severity={snackBarType}
					variant="filled"
					sx={{ width: "100%" }}>
					{snackBarMessage}
				</Alert>
			</Snackbar>
		</>
	);
};
